module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', [_c('div', {
    staticClass: "item"
  }, [_vm._v("微信昵称：" + _vm._s(_vm.nickname ? _vm.nickname : "尚未绑定微信"))]), _vm._v(" "), (_vm.nickname) ? _c('div', {
    staticClass: "item center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.unbindWechat
    }
  }, [_vm._v("取消绑定")])], 1) : _c('div', {
    staticClass: "item center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.bindWechat
    }
  }, [_vm._v("绑定微信")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7277500c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/staff/wechat.vue
// module id = 1172
// module chunks = 2